import { type QueryClient } from '@tanstack/react-query';

import {
  type BankAccountWithDetails,
  bankAccountGetBankAccountQueryKey,
  bankAccountListBankAccounts,
} from '@column/api';

const BATCH_SIZE = 100;

export const prefetchBankAccountsByIds = async (queryClient: QueryClient, bankAccountIds: string[]) => {
  const uniqueIds = Array.from(new Set(bankAccountIds.filter(Boolean)));

  for (let i = 0; i < uniqueIds.length; i += BATCH_SIZE) {
    const ids = uniqueIds.slice(i, i + BATCH_SIZE);
    const { data } = await bankAccountListBankAccounts({
      query: { bank_account_ids: ids.join(','), limit: BATCH_SIZE },
      throwOnError: false,
    });
    (data?.bank_accounts ?? []).forEach((ba: BankAccountWithDetails) => {
      if (!ba.id) return;
      queryClient.setQueryData<BankAccountWithDetails>(
        bankAccountGetBankAccountQueryKey({ path: { bank_account_id: ba.id } }),
        ba
      );
    });
  }
};
